import { render, staticRenderFns } from "./TreatmentsPatient.vue?vue&type=template&id=32956201&scoped=true"
import script from "./TreatmentsPatient.vue?vue&type=script&lang=js"
export * from "./TreatmentsPatient.vue?vue&type=script&lang=js"
import style0 from "./TreatmentsPatient.vue?vue&type=style&index=0&id=32956201&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32956201",
  null
  
)

export default component.exports